/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/string/CharactersCount.ts
 * @create:      2025-06-26 10:14:56.799
 * @modify:      2025-07-11 21:19:12.857
 * @version:     6.0.0
 * @times:       14
 * @lines:       66
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { Strings_Empty } from "../const/Strings";
import { StringDistinct } from "./StringDistinct";

/**
 * Counts the number of occurrences of the specified characters in a given string.
 *
 * @param str - The string to search within.
 * @param characters - The characters to count occurrences of. Accepts one or more characters as separate arguments.
 * @returns The total count of occurrences of the specified characters in the input string.
 *
 * @remarks
 * - Each character in `characters` is considered only once, even if repeated in the arguments.
 * - If `str` is empty, the function returns 0.
 * 
 * @since 4.0.0
 * @version 2025-07-09
 */
export function CharactersCount(str: string, ...characters: string[]) {

    if (!str) {
        return 0;
    }

    let count = 0;
    const charactersStr = StringDistinct(characters.join(Strings_Empty));
    for (const val of str) {
        if (charactersStr.includes(val)) {
            count++;
        }
    }

    return count;
}
